export { default } from './CGMStatusItem';
